export default {
  tourData: {
    fallback: {
      included: ['Tour included', 'Local support', 'Exclusive experience in Paraty'],
      notIncluded: ['Meals and drinks', 'Hotel transfer'],
      bringItems: ['Sunscreen', 'Light clothing', 'Water', 'Camera'],
      meetingPoint: 'Paraty, RJ',
      startTime: 'To be confirmed',
      maxGroupSize: 'Group',
      cancellation: "Please check the tour's cancellation policy.",
      privacyPolicy: 'Privacy policy available on the website.',
      importantNotes: ['Confirm the departure time with our team before the tour.'],
      genericTag: 'Boat tour',
    },
  },
};
